module.exports = __webpack_public_path__ + "diagram.56c3cc88ec3c1ac16105.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/diagram.svg
// module id = ../../../../../src/assets/img/diagram.svg
// module chunks = main